import styled, { css } from 'styled-components';

export const CreateNewMyAuditButtonContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const NoResultContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing.xxl};
    gap: ${theme.spacing.m};
    align-items: center;
  `
);

export const NoResults = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.spacing.xxl};
  `
);
export const NoDataMessageContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const SelfAssessmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 100px ${({ theme }) => theme.spacing.sm};
  margin-bottom: 88px;
  row-gap: ${({ theme }) => theme.spacing.m};
  margin-top: 160px;
`;

export const ContentArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.oxfordBlue};
  z-index: 900;
`;

export const DepartmentHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const LoaderContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.xm} 0;
`;

export const FilterModalContent = styled('div')`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const FilterModalHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  margin: ${({ theme }) => theme.spacing.l} 0 ${({ theme }) => theme.spacing.xm}
    0;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  & .radio-with-label-label-wrapper {
    padding-left: ${({ theme }) => theme.spacing.s};
  }
  & .radio-with-label-label {
    font-size: ${({ theme }) => theme.fontSize.s};
  }
  & span {
    background-color: transparent !important;

    &:before {
      background-color: ${({ theme }) => theme.colors.verdigris};
      width: 12px;
      height: 12px;
    }
  }
  & .radio-with-label-label {
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-size: ${({ theme }) => theme.fontSize.s};
    color: ${({ theme }) => theme.colors.dimGray};
    letter-spacing: 0;
    line-height: ${({ theme }) => theme.lineHeight.lh5};
  }

  & .control-radio-overflow INPUT {
    display: none;
  }
`;

export const BottomSheetButtonSpacing = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.fontSize.s};
`;

export const ActionButtonContainer = styled.div`
  gap: ${({ theme }) => theme.spacing.m};
  margin: ${({ theme }) => theme.spacing.m} 0;
  display: flex;
  justify-content: space-around;
`;

export const CardContentWrapper = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.m};
`;

export const DepartmentContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  flex-direction: column;
`;

export const SortContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const StatusRadioReceivedWrapper = styled.span(
  ({ theme, checked }) => css`
    & .radio-with-label-label {
      color: ${checked ? theme.colors.eerieBlack : theme.colors.dimGray};
    }
  `
);

export const StatusRadioCreatedByWrapper = styled.span(
  ({ theme, checked }) => css`
    & .radio-with-label-label {
      color: ${checked ? theme.colors.eerieBlack : theme.colors.dimGray};
    }
  `
);

export const StatusRadioAssessedWrapper = styled.span(
  ({ theme, checked }) => css`
    & .radio-with-label-label {
      color: ${checked ? theme.colors.eerieBlack : theme.colors.dimGray};
    }
  `
);

export const SearchFieldInput = styled.input`
  flex: 1;
  height: ${({ theme }) => theme.spacing.xm};
  margin-left: ${({ theme }) => theme.spacing.s};
  margin-right: ${({ theme }) => theme.spacing.s};
  border: none;
  background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.sm};
  outline: none;
  padding: ${({ theme }) => theme.spacing.none};

  ::placeholder {
    color: ${({ theme }) => theme.colors.silver};
  }

  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.dimGray};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  }
`;

export const DisabledSearchBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  border-radius: ${({ theme }) => theme.radius.s};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
`;

export const IconContainer = styled.div`
  display: flex;
`;

export const FilterInputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const FilterStatusContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const FilterLabelContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const SelfAssessmentDatePickerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const InputContainer = styled.div`
  justify-content: center;
  align-items: center;
  position: ${({ theme }) => theme.positions.relative};
  width: 100%;

  & .self-assessment-filter-date-picker {
    height: ${({ theme }) => theme.height.h6};
    width: 100%;
    border: ${({ theme }) => `1px solid ${theme.colors.platinumDark}`};
    border-radius: ${({ theme }) => theme.spacing.s};
    padding: 0 11px; // added this temporarily when doing a myLqa revamp this will be removed
  }
`;

export const CalendarIconContainer = styled.div`
  position: ${({ theme }) => theme.positions.absolute};
  top: 14px;
  right: ${({ theme }) => theme.spacing.m};
`;
